import React, { useState } from "react";
import "./PrestataireCard.css";
import { getVideoSources } from "../../utils/video";
import PdfModal from "../PdfModal";
import ImageModal from "../ImageModal";
import { Document, Page, pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export default function PrestataireCard({ prestataire, apiUrl, onValidate, onSkip }) {
    // format date FR
    const formatDate = (date) =>
        new Date(date).toLocaleDateString("fr-FR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        });
    const [pdfUrl, setPdfUrl] = useState(null);
    const [imageUrl, setImageUrl] = useState(null); // ⬅️ nouvel état

    const openPdf = (file, categorie) => {
        setPdfUrl(`${apiUrl}/api/files/?categorie=${categorie}&file=${file}`);
    };

    return (
        <div className="prestataire-card">
            {/* Raison sociale en titre principal */}
            <h2 className="raison-sociale">{prestataire.raisonSocialePrestataire}</h2>

            {/* Logo + Photo centré */}
            <div className="header-photos">
                {prestataire.logoPrestataire && (
                    <img
                        src={`${apiUrl}/api/files/?categorie=logosPrestataires&file=${prestataire.logoPrestataire}`}
                        alt="Logo"
                        className="mini-logo"
                        onClick={() => setImageUrl(`${apiUrl}/api/files/?categorie=logosPrestataires&file=${prestataire.logoPrestataire}`)}

                    />
                )}
                {prestataire.photoProfilPrestataire && (
                    <img
                        src={`${apiUrl}/api/files/?categorie=photosPrestataires&file=${prestataire.photoProfilPrestataire}`}
                        alt="Profil"
                        className="mini-photo"
                        onClick={() => setImageUrl(`${apiUrl}/api/files/?categorie=photosPrestataires&file=${prestataire.photoProfilPrestataire}`)}

                    />
                )}
            </div>

            {/* Infos entreprise & responsable */}
            <div className="info-sections">
                <div className="mini-card">
                    <h3>Entreprise</h3>
                    <p><strong>SIRET :</strong> {prestataire.siretPrestataire}</p>
                    <p><strong>Adresse :</strong> {prestataire.adressePrestataire}, {prestataire.codePostalPrestataire} {prestataire.villePrestataire}</p>
                    <p><strong>Pays :</strong> {prestataire.paysPrestataire.toUpperCase()}</p>
                    {prestataire.siteWebPrestataire && (
                        <p>
                            🌐 <a href={prestataire.siteWebPrestataire} target="_blank" rel="noreferrer">
                                {prestataire.siteWebPrestataire}
                            </a>
                        </p>
                    )}
                </div>

                <div className="mini-card">
                    <h3>Responsable</h3>
                    <p><strong>{prestataire.firstNamePrestataire} {prestataire.lastNamePrestataire}</strong></p>
                    <p>📅 Né(e) le {formatDate(prestataire.dateNaissancePrestataire)}</p>
                    <p>📞 {prestataire.telephonePrestataire}</p>
                </div>
            </div>

            {/* Description */}
            {prestataire.descriptionPrestataire && (
                <div className="section">
                    <h3>Présentation</h3>
                    <p>{prestataire.descriptionPrestataire}</p>
                </div>
            )}
            {/* Présentation vidéo */}
            {prestataire.videoPresentationPrestataire && (
                <div className="section">
                    <h3>Présentation vidéo</h3>
                    <video
                        controls
                        width="100%"
                        className="video-presentation"
                        poster={`${apiUrl}/api/files/?categorie=photosPrestataires&file=${prestataire.photoProfilPrestataire}`}
                    >
                        {getVideoSources(prestataire.videoPresentationPrestataire, apiUrl).map(
                            (src, idx) => (
                                <source key={idx} src={src.src} type={src.type} />
                            )
                        )}
                        Votre navigateur ne supporte pas la lecture vidéo.
                    </video>
                    {prestataire.descriptionPrestataire && (
                        <p>{prestataire.descriptionPrestataire}</p>
                    )}
                </div>
            )}

            {/* Intervenants */}
            {prestataire.intervenants?.length > 0 && (
                <div className="section">
                    <h3>Intervenants</h3>
                    <div className="intervenants-list">
                        {prestataire.intervenants.map((i) => (
                            <div key={i.idIntervenant} className="intervenant-card">
                                <img
                                    src={`${apiUrl}/api/files/?categorie=intervenants&file=${i.photoProfilIntervenant}`}
                                    alt={i.nomIntervenant}
                                    className="intervenant-photo"
                                    onClick={() => setImageUrl(`${apiUrl}/api/files/?categorie=intervenants&file=${i.photoProfilIntervenant}`)}
                                />
                                <div>
                                    <p><strong>{i.prenomIntervenant} {i.nomIntervenant}</strong></p>
                                    <p>{i.metier.labelMetier}</p>
                                    <p>📞 {i.telephoneIntervenant}</p>
                                    <p>📧 {i.emailIntervenant}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* Réalisations */}
            {prestataire.realisations?.length > 0 && (
                <div className="section">
                    <h3>Réalisations</h3>
                    <div className="realisations-list">
                        {prestataire.realisations.map((r) => (
                            <div key={r.id} className="realisation-card">
                                <p><strong>{r.titre}</strong></p>
                                {r.photos?.length > 0 && (
                                    <div className="realisation-photos">
                                        {r.photos.map((photo, idx) => (
                                            <img
                                                key={idx}
                                                src={`${apiUrl}/api/files/?categorie=realisations&file=${photo}`}
                                                alt={`realisation-${idx}`}
                                                className="realisation-photo"
                                            />
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* Documents */}
            <div className="section">
                <h3>Documents</h3>
                <div className="documents-list">
                    {prestataire.justifIdentite && (
                        <div className="doc-item">
                            <p>🪪 Identité</p>
                            {prestataire.justifIdentite.endsWith(".pdf") ? (
                                <div
                                    className="pdf-thumbnail"
                                    onClick={() => openPdf(prestataire.justifIdentite, "verifPresta")}
                                >
                                    <Document
                                        file={`${apiUrl}/api/files/?categorie=verifPresta&file=${prestataire.justifIdentite}`}
                                    >
                                        <Page pageNumber={1} width={120} /> {/* miniature */}
                                    </Document>
                                </div>
                            ) : (
                                <img
                                    src={`${apiUrl}/api/files/?categorie=verifPresta&file=${prestataire.justifIdentite}`}
                                    alt="Identité"
                                    className="doc-image"
                                    onClick={() =>
                                        setImageUrl(
                                            `${apiUrl}/api/files/?categorie=verifPresta&file=${prestataire.justifIdentite}`
                                        )
                                    }
                                />
                            )}

                        </div>
                    )}

                    {prestataire.justifEntreprise && (
                        <div className="doc-item">
                            <p>🏢 Entreprise</p>
                            {prestataire.justifEntreprise.endsWith(".pdf") ? (
                                <div
                                    className="pdf-thumbnail"
                                    onClick={() => openPdf(prestataire.justifEntreprise, "verifPresta")}
                                >
                                    <Document
                                        file={`${apiUrl}/api/files/?categorie=verifPresta&file=${prestataire.justifEntreprise}`}
                                    >
                                        <Page pageNumber={1} width={120} /> {/* miniature */}
                                    </Document>
                                </div>
                            ) : (
                                <img
                                    src={`${apiUrl}/api/files/?categorie=verifPresta&file=${prestataire.justifEntreprise}`}
                                    alt="Entreprise"
                                    className="doc-image"
                                    onClick={() => setImageUrl(`${apiUrl}/api/files/?categorie=verifPresta&file=${prestataire.justifEntreprise}`)}
                                />
                            )}
                        </div>
                    )}

                    {prestataire.justifSpecifique && (
                        <div className="doc-item">
                            <p>📄 Spécifique</p>
                            {prestataire.justifSpecifique.endsWith(".pdf") ? (
                                <div
                                    className="pdf-thumbnail"
                                    onClick={() => openPdf(prestataire.justifSpecifique, "verifPresta")}
                                >
                                    <Document
                                        file={`${apiUrl}/api/files/?categorie=verifPresta&file=${prestataire.justifSpecifique}`}
                                    >
                                        <Page pageNumber={1} width={120} /> {/* miniature */}
                                    </Document>
                                </div>
                            ) : (
                                <img
                                    src={`${apiUrl}/api/files/?categorie=verifPresta&file=${prestataire.justifSpecifique}`}
                                    alt="Spécifique"
                                    className="doc-image"
                                    onClick={() => setImageUrl(`${apiUrl}/api/files/?categorie=verifPresta&file=${prestataire.justifSpecifique}`)}
                                />
                            )}
                        </div>
                    )}
                </div>

                {/* Modale PDF */}
                {pdfUrl && <PdfModal fileUrl={pdfUrl} onClose={() => setPdfUrl(null)} />}
                {imageUrl && <ImageModal imageUrl={imageUrl} onClose={() => setImageUrl(null)} />}
            </div>

            {/* Actions */}
            <div className="actions">
                <button className="btn btn-secondary" onClick={onSkip}>
                    Passer
                </button>
                <button className="btn btn-primary" onClick={() => onValidate(prestataire.idPrestataire)}>
                    Valider
                </button>
            </div>
        </div>
    );
}
